import Box from "./Box";
import Button from "./Button";
import PropTypes from "prop-types";
import React from "react";

function Toggle({ active, onClick, ariaLabel }) {
  return (
    <Button
      height={16}
      width={30}
      p="1px"
      bg={active ? "green" : "lightGrey"}
      borderRadius={9999}
      position="relative"
      onClick={onClick}
      aria-label={ariaLabel}
    >
      <Box
        height={14}
        width={14}
        bg="white"
        borderRadius="100%"
        position="absolute"
        top="1px"
        transition="transform 50ms ease-out"
        transform={active ? "translate3d(14px,0,0)" : "translate3d(0,0,0)"}
      />
    </Button>
  );
}

export default Toggle;

Toggle.propTypes = {
  active: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};
